export const GET_MOBILE_FINNANCE_SUCCESS = "GET_MOBILE_FINNANCE_SUCCESS";
export const GET_MOBILE_FINNANCE_FAIL = "GET_MOBILE_FINNANCE_FAIL";
export const GET_MOBILE_FINNANCE_REQUEST = "GET_MOBILE_FINNANCE_REQUEST";
export const GET_ALL_MOBILE_FINNANCE_SUCCESS = "GET_ALL_MOBILE_FINNANCE_SUCCESS";
export const GET_ALL_MOBILE_FINNANCE_FAIL = "GET_ALL_MOBILE_FINNANCE_FAIL";
export const GET_ALL_MOBILE_FINNANCE_REQUEST = "GET_ALL_MOBILE_FINNANCE_REQUEST";
export const GET_MOBILE_FINNANCE_UPDATE_SUCCESS = "GET_MOBILE_FINNANCE_UPDATE_SUCCESS";
export const GET_MOBILE_FINNANCE_UPDATE_FAIL = "GET_MOBILE_FINNANCE_UPDATE_FAIL";
export const GET_MOBILE_FINNANCE_UPDATE_REQUEST = "GET_MOBILE_FINNANCE_UPDATE_REQUEST";
export const GET_MOBILE_FINNANCE_UPDATE_RESET = "GET_MOBILE_FINNANCE_UPDATE_RESET";
export const GET_CLIENT_SUCCESS = "GET_CLIENT_SUCCESS";
export const GET_CLIENT_FAIL = "GET_CLIENT_FAIL";
export const GET_CLIENT_REQUEST = "GET_CLIENT_REQUEST";
export const GET_ALL_CLIENT_SUCCESS = "GET_ALL_CLIENT_SUCCESS";
export const GET_ALL_CLIENT_FAIL = "GET_ALL_CLIENT_FAIL";
export const GET_ALL_CLIENT_REQUEST = "GET_ALL_CLIENT_REQUEST";
export const GET_CLIENT_UPDATE_SUCCESS = "GET_CLIENT_UPDATE_SUCCESS";
export const GET_CLIENT_UPDATE_FAIL = "GET_CLIENT_UPDATE_FAIL";
export const GET_CLIENT_UPDATE_REQUEST = "GET_CLIENT_UPDATE_REQUEST";
export const GET_CLIENT_UPDATE_RESET = "GET_CLIENT_UPDATE_RESET";
export const GET_ALL_CLIENTS_SUCCESS = "GET_ALL_CLIENTS_SUCCESS";
export const GET_ALL_CLIENTS_FAIL = "GET_ALL_CLIENTS_FAIL";
export const GET_ALL_CLIENTS_REQUEST = "GET_ALL_CLIENTS_REQUEST";


